









import { Component, Vue } from 'vue-property-decorator';
import { event as initEvent } from '@/events/init';
import ProgressBar from '@/components/UI/Progress.vue';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import ui from '@/store/modules/ui';
import store from '@/store';
import { get as dataGetter } from 'lodash';
import { i18n } from '@/i18n';
import scriptLoad from '@/commons/scriptLoad';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
  components: {
    ProgressBar,
  },
})
export default class App extends Vue {

  get componentKeys(): Record<string, string> {
    return ui.componentKeys;
  }

  get isLoading(): boolean {
    return cart.loadingFlags.registrationlogin || cart.loadingFlags.processingpayment;
  }

  get loadingMessage(): string {
    if (cart.loadingFlags.registrationlogin) {
      return i18n.t('Wait for page to reload').toString();
    }
    if (cart.loadingFlags.processingpayment) {
      return i18n.t('Please wait, payment is processing').toString();
    }
    return '';
  }

  // tutorial: il metodo mounted è un hook del ciclo di vita del componente.
  // Viene invocato dopo che il componente è stato renderizzato nel DOM della pagina
  // https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
  private mounted() { // in npm run serve
    scriptLoad('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', true);
    if (cart.isBlackboxEnabled && !cart.isEmpty) {
      var ans =  checkout.checkPromoOnTicket();
      ans.then(() => {
        gtmhelpers.trackViewCart(
            gtmhelpers.convertProductsData(cart.cart.items),
            cart.totals.grand_total,
            cart.totals.quote_currency_code,
            checkout.coupon.coupon
        );
        if(store.state.options.gtm.extraEventsAjax){
          store.state.options.gtm.extraEventsAjax.forEach((event:any) => {
            gtmhelpers.gtmPush(event);
          });
        }
      } );
    }
    gtmhelpers.trackUserEvent(store.state.options.gtm.userEvent);
    if(store.state.options.gtm.extraEvents){
      store.state.options.gtm.extraEvents.forEach((event:any) => {
        gtmhelpers.gtmPush(event);
      });
    }
    if (process.env.NODE_ENV !== 'production') {
      let resolveProm: any;
      let rejectProm: any;
      const promise = new Promise((resolve, reject) => {
        resolveProm = resolve;
        rejectProm = reject;
      });
      let initPayload: any;
      console.log('Serve app as', process.env.VUE_APP_FLOW);
      if (process.env.VUE_APP_FLOW === 'guest') {
        initPayload = {cart: process.env.VUE_APP_CARTID, resolveProm, rejectProm};
      } else if (process.env.VUE_APP_FLOW === 'logged') {
        initPayload = {user: process.env.VUE_APP_USER, pass: process.env.VUE_APP_PASS, resolveProm, rejectProm};
      } else if (process.env.VUE_APP_FLOW === 'loggedsess') {
        if (localStorage.getItem('usertoken')) {
          initPayload = {token: localStorage.getItem('usertoken'), resolveProm, rejectProm};
        } else {
          initPayload = {cart: process.env.VUE_APP_CARTID, resolveProm, rejectProm};
        }
      } else {
        throw Error('Flow not supported');
      }
      this.$eventBus.$emit(initEvent, initPayload);

      promise.then(() => {
        if (!cart.shippingAssignementAddress) {
          checkout.assignShippingAddress(checkout.shippingAddress);
        }
        ui.reloadComponentKeys();
      });
    } else { // in npm run build
      const initialState = window.__INITIAL_STATE__ || {};

      // watch initial state props and commit mutations
      const watchInitialState: any = {
        'cart.id': {mutation: 'cart/setCart', payload: 'cart'},
      };
      for (const k in watchInitialState) {
        if (dataGetter(initialState, k)) {
          store.commit(watchInitialState[k].mutation, dataGetter(initialState, watchInitialState[k].payload));
        }
      }

      this.$eventBus.$emit(initEvent, {initialState});
    }
  }
}
